import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getUserTravelInfo, travel } from "@/helper/contractFunctions/MafiaProfile";
import { TravelInfo } from "@/types/Contract/Profile/TravelInfo";

export interface TravelState {
  userTravelInfo: TravelInfo;
  isTraveling: boolean;
  isGettingTravelInfo: boolean;
}

const initialState: TravelState = {
  userTravelInfo: { travelType: -1, travelUntil: -1, itemId: -1 },
  isTraveling: false,
  isGettingTravelInfo: false,
};

export const travelAction = createAsyncThunk(
  "travel/travelAction",
  async ({ destinationCity, travelType, itemId, account }: { destinationCity: number; travelType: number; itemId: number; account: string }) => {
    const txData = await travel(destinationCity, travelType, itemId, account);
    return txData.transactionHash;
  }
);

export const getUserTravelInfoAction = createAsyncThunk(
  "travel/getUserTravelInfoAction",
  async ({ account, signature, signMsg }: { account: string; signature: string; signMsg: string }) =>
    getUserTravelInfo(account, signature, signMsg)
);

const travelSlice = createSlice({
  name: "travel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(travelAction.pending, (state) => { state.isTraveling = true; })
      .addCase(travelAction.fulfilled, (state) => { state.isTraveling = false; })
      .addCase(travelAction.rejected, (state) => { state.isTraveling = false; })
      .addCase(getUserTravelInfoAction.pending, (state) => { state.isGettingTravelInfo = true; })
      .addCase(getUserTravelInfoAction.fulfilled, (state, { payload }) => {
        state.userTravelInfo = payload;
        state.isGettingTravelInfo = false;
      })
      .addCase(getUserTravelInfoAction.rejected, (state) => { state.isGettingTravelInfo = false; });
  },
});

export default travelSlice.reducer;
